// extracted by mini-css-extract-plugin
module.exports = {"video-container":"videoPlayerComponent_video-container__IryL6"};